// File generated by MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents

export class IssueResolutionListDto  {
  entityIdList: string[] = [];
}

export interface IssueResolutionListDtoFormGroup  {
  entityIdList?: any;
}
